import styled, { createGlobalStyle } from "styled-components";

export const StyledGlobalTooltip = createGlobalStyle`
  .ant-tooltip-inner {
    max-width: 600px !important;
    max-height: 400px !important;
    overflow-y: scroll;
    display: flex !important;
    flex-direction: column !important;
    padding: 10px !important;
    border-radius: 4px !important;
    background-color: ${({ theme }) => theme.colors.surface.surface} !important;

    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface} !important;
  }

  .ant-tooltip .ant-tooltip-arrow:before {
    background: ${({ theme }) => theme.colors.surface.surface} !important;
  }

  .ant-alert-warning {
    display: flex;
    align-items: center !important;
  }
`;

export const AvatarWrapperWithTooltip = styled.div`
  &+& {
    margin-left: 4px;
  }
`;
